import { useState } from 'react';
import type { TrialAnswer } from '../appMachine';

interface AnswerPanelProps {
  onAnswer: (answer: TrialAnswer) => void;
}

export function AnswerPanel({ onAnswer }: AnswerPanelProps) {
  const [userAnswer, setUserAnswer] = useState('');
  const [noticed, setNoticed] = useState<'yes' | 'no'>('no');
  const [confidence, setConfidence] = useState(3);
  const [anomalyText, setAnomalyText] = useState('');
  const [startedAt] = useState(() => performance.now());

  return (
    <form className="card answerCard" onSubmit={(event) => {
      event.preventDefault();
      onAnswer({
        userAnswer: Number.parseInt(userAnswer || '0', 10),
        noticed: noticed === 'yes',
        confidence,
        anomalyText: anomalyText.trim() || undefined,
        reactionMs: Math.round(performance.now() - startedAt)
      });
    }}>
      <h2>Lock your perception before reveal</h2>
      <label>
        Count: how many target objects crossed left-to-right through the gate?
        <input autoFocus inputMode="numeric" pattern="[0-9]*" value={userAnswer} onChange={(e) => setUserAnswer(e.target.value.replace(/\D/g, '').slice(0, 3))} placeholder="0" required />
      </label>
      <fieldset>
        <legend>Before the reveal, did you notice anything unexpected?</legend>
        <label><input type="radio" name="noticed" checked={noticed === 'no'} onChange={() => setNoticed('no')} /> No</label>
        <label><input type="radio" name="noticed" checked={noticed === 'yes'} onChange={() => setNoticed('yes')} /> Yes</label>
      </fieldset>
      <label>
        Confidence
        <input type="range" min="1" max="5" value={confidence} onChange={(e) => setConfidence(Number(e.target.value))} />
        <span>{confidence}/5</span>
      </label>
      <label>
        Optional: what did you notice?
        <textarea value={anomalyText} onChange={(e) => setAnomalyText(e.target.value)} maxLength={500} placeholder="A giant... maybe?" />
      </label>
      <button type="submit" className="primary">Reveal the obvious thing</button>
    </form>
  );
}
